export default "__VITE_ASSET__BjSlk9ey__"